module.exports = __webpack_public_path__ + "a6860bccc60f1b9997d3b69e5529b0da.pdf";